import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Chip from "@mui/material/Chip";
import axios from "axios";
import API_ENDPOINTS from "config/api";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DataTable from "examples/Tables/DataTable";

export default function Categorias() {
  const [categorias, setCategorias] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [categoriaForm, setCategoriaForm] = useState({
    id: null,
    codigo: "",
    nombre: "",
    descripcion: "",
    categoria_padre_id: null,
    estado: "activo",
  });

  const empresaId = localStorage.getItem("empresaId");

  useEffect(() => {
    fetchCategorias();
  }, [empresaId]);

  const fetchCategorias = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.CATEGORIAS, {
        params: { empresa_id: empresaId },
      });
      setCategorias(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error al obtener categorías:", error);
      setCategorias([]);
    }
  };

  const handleOpenDialog = (categoria = null) => {
    if (categoria) {
      setCategoriaForm(categoria);
    } else {
      setCategoriaForm({
        id: null,
        codigo: "",
        nombre: "",
        descripcion: "",
        categoria_padre_id: null,
        estado: "activo",
      });
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCategoriaForm({ ...categoriaForm, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const data = { ...categoriaForm, empresa_id: empresaId };
      if (categoriaForm.id) {
        await axios.put(API_ENDPOINTS.CATEGORIA(categoriaForm.id), data);
      } else {
        await axios.post(API_ENDPOINTS.CATEGORIAS, data);
      }
      fetchCategorias();
      handleCloseDialog();
    } catch (error) {
      console.error("Error al guardar categoría:", error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Está seguro de eliminar esta categoría?")) {
      try {
        await axios.delete(API_ENDPOINTS.CATEGORIA(id));
        fetchCategorias();
      } catch (error) {
        console.error("Error al eliminar categoría:", error);
      }
    }
  };

  const columns = [
    { Header: "Código", accessor: "codigo", width: "15%", align: "left" },
    { Header: "Nombre", accessor: "nombre", align: "left" },
    { Header: "Descripción", accessor: "descripcion", width: "30%", align: "left" },
    { Header: "Productos", accessor: "productos", width: "10%", align: "center" },
    { Header: "Estado", accessor: "estado", width: "10%", align: "center" },
    { Header: "Acciones", accessor: "acciones", width: "10%", align: "center" },
  ];

  const rows = categorias.map((categoria) => ({
    codigo: categoria.codigo,
    nombre: categoria.nombre,
    descripcion: categoria.descripcion,
    productos: categoria.total_productos || 0,
    estado: (
      <Chip
        label={categoria.estado === "activo" ? "Activo" : "Inactivo"}
        color={categoria.estado === "activo" ? "success" : "default"}
        size="small"
      />
    ),
    acciones: (
      <MDBox display="flex" gap={1} justifyContent="center">
        <IconButton size="small" color="info" onClick={() => handleOpenDialog(categoria)}>
          <Icon>edit</Icon>
        </IconButton>
        <IconButton size="small" color="error" onClick={() => handleDelete(categoria.id)}>
          <Icon>delete</Icon>
        </IconButton>
      </MDBox>
    ),
  }));

  return (
    <MDBox>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <MDTypography variant="h6">Categorías de Productos</MDTypography>
        <MDButton
          variant="gradient"
          color="success"
          startIcon={<Icon>add</Icon>}
          onClick={() => handleOpenDialog()}
        >
          Nueva Categoría
        </MDButton>
      </MDBox>

      <Card>
        <MDBox>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>

      {/* Dialog para crear/editar categoría */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{categoriaForm.id ? "Editar Categoría" : "Nueva Categoría"}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Código"
                name="codigo"
                value={categoriaForm.codigo}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre"
                name="nombre"
                value={categoriaForm.nombre}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descripción"
                name="descripcion"
                value={categoriaForm.descripcion}
                onChange={handleInputChange}
                multiline
                rows={3}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancelar</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            {categoriaForm.id ? "Actualizar" : "Crear"}
          </Button>
        </DialogActions>
      </Dialog>
    </MDBox>
  );
}
